import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../feature-module/router/all_routes";

interface EnableRecurringModalProps {
  show: boolean;
  onHide: () => void;
  uuid: string | null;
  userRole: string;
  onSuccess?: () => void;
}

const EnableRecurringModal: React.FC<EnableRecurringModalProps> = ({ show, onHide, uuid, userRole, onSuccess }) => {

  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const routes = all_routes;

  const handleGoToEdit = () => {
    if (uuid) {
      if (userRole == "owner") {
        navigate(`/mileage/add/${uuid}`);
      }
      else {
        navigate(`/spouse/mileage/add/${uuid}`);
      }

      onHide();
      onSuccess?.();
    }
  };

  const handleCancel = () => {
    onHide();
  };

  return (
    <Modal className="recurring_modal" show={show} onHide={handleCancel} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Recurring Mileage</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>
          To enable recurring process, please go to the <strong>Edit</strong> section to configure recurrence settings.
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleCancel}>
          Cancel
        </Button>
        <Button variant="primary" className="primaryButton" onClick={handleGoToEdit} disabled={!uuid}>
          Go to Edit
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EnableRecurringModal;